module.exports = __webpack_public_path__ + "img/data-rocket-circle.85585ca4.svg";